<template lang="pug">
v-container.px-10(fluid)
  v-progress-linear(
    :active="loading",
    indeterminate,
    color="white",
    absolute,
    top
  )
  v-row.text-center(v-if="!entity")
    v-col.py-0
      h2.primary--text {{$t('Common.noEntitySelected')}}
      small.white--text {{$t('Common.selectEntityHelp')}}
  v-row(v-else)
    v-col.py-0
      v-card.px-10.py-5.my-5
        v-col.py-0.text-right
          v-btn(color="primary", @click="refresh") {{$t('Common.refresh')}}
            v-icon  mdi-refresh
        v-overlay(absolute, v-if="loading")
        g-data-table(
          dense,
          :headers="headers",
          :items="pagination.data",
          :options.sync="options",
          :server-items-length="pagination.total",
          v-bind="{ loading }",
        )
          template(v-slot:no-data)
            h2 {{ $t("Common.entityNoItems", { entity : $pascalToHuman(entityName)}) }}
            small {{ $t('Common.entityNoItemsHelp') }}
          template(v-slot:top)
            app-entity-search(
              :criteria="$getInitialCriterias($route.params.criteria, pagination.where)",
              @pagination="pagination = $event",
              :loads="loads",
              :entity="entity",
            )
  v-row
    v-snackbar(v-model="snackbar")
      | {{ message }}
      v-btn(color="pink", text, @click="snackbar = false")
</template>

<style type="text/css">
.v-data-table td {
  white-space: nowrap;
}
.top-right {
  position: absolute;
  top: 1rem;
  right: .5rem;
}
</style>

<script>
import axios from 'axios'
import moment from 'moment-timezone'
import keys from 'lodash/keys'
import { AppEntityDelete } from '@@/components'
import AppEntityAutocomplete from '@@/components/EntityAutocomplete.vue'
import EntiyLoadsMixin from "@/mixins/entity-loads.mixin";
import IndexFilterMixin from '@/mixins/index-filter.mixin';

export default {
  components: {
    AppEntityDelete,
    AppEntityAutocomplete
  },
  name: 'errorlog-index',
  mixins: [
    EntiyLoadsMixin,
    IndexFilterMixin,
  ],
  data: () => ({
    entityName: 'ErrorLog',
    message: '',
    snackbar: false,
    loading: false,
    timer: null,
    wait: 500,
    pagination: {},
    options: {},
    loads: [],
  }),

  watch: {
    $route: {
      immediate: true,
      handler () {
        this.clear();
        this.loads = _.get(ENV.ENTITIES, `${this.entityName}.index.add`, [])
          .filter(x => x.load)
          .map(x => x.load);
        this.load(this.options);
      }
    },
    options: {
      handler (options) {
        this.load(options)
      }
    }
  },

  computed: {
    has () {
      return !!this.items.length
    },
    entity () {
      return this.$searchEntity(this.entityName)
    },
    headers() {
      return ([
        { text: this.$t("ErrorLog.Id"), value: "id" },
        { text: this.$t("ErrorLog.createdAt"), value: "recordedAt" },
        { text: this.$t("ErrorLog.entity"), value: "entity" },
        { text: this.$t("ErrorLog.exception"), value: "exception" },
      ]);
    },
  },
  methods: {
    getPagination(options = null, where = null) {
      options = options || this.options
      if (!keys(options).length) return
      return {
        params: {
          page: options.page,
          pageSize: options.itemsPerPage,
          orderBy: options.sortBy[0],
          desc: options.sortDesc[0],
          where: where,
        }
      }
    },
    /* TODO: docs */
    async load (options = null) {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        const pagination = this.getPagination(options, this.pagination.where)
        if (this.entity) {
          this.loading = true
          var criteria = this.$route.params.criteria ? { Where: [this.$route.params.criteria.value] } : null
          pagination.params = {...pagination.params, ...criteria, withoutGlobalBusinessScope:true }
          try {
            // const envEndpoint = _.get(ENV.ENTITIES, this.entityName  + '.index.endpoint', this.entityName);
            // const envParams = _.get(ENV.ENTITIES, this.entityName  + '.index.params', {});
            // pagination.params = _.merge(pagination.params, envParams);
            const paginationresult = (await axios.get(this.$fetchLoad(this.entityName, ...this.loads), pagination)).data;
            paginationresult.data = (paginationresult.data || []).map(d => ({
              // The date should be a UTC format, otherwise it's not going to work.
              ...d,
              // TODO: implement env ignoreTimezone here, find a way to make it generic.
              createdAt: moment(d.createdAt).format('YYYY-MM-DD HH:mm'),
            }));
            this.pagination = paginationresult;
          } catch (err) {}
          this.loading = false
        }
      }, this.wait)
    },

    /* TODO: docs */
    async remove (entity) {
      this.loading = true
      entity.entityState = ENV.ENTITY.STATE.DELETED
      try {
        await axios.post('entity/graph', entity)
      } catch (e) {
        this.snackbar = true
        this.message = e.response && e.response.data.message
      }
      await this.load(this.options)
    },

    getEditAttribute(item) {
      return _.get(item, _.get(ENV.ENTITIES, this.entityName  + '.index.editAttribute', 'uid'));
    },

    clear () {
      this.options = {
        ...this.options,
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      };
    },
    refresh () {
      this.clear();
      this.load();
    }
  },
  created() {

  }
}
</script>
